import React from "react";
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export default function InputMaxValue(props) {
  const { inputRef, onChange, max, isNumeric, ...numberFormatProps } = props;

  let numeric = isNumeric || false;

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value > max) {
      return false;
    } else {
      return true;
    }
  };
  return (
    <NumberFormat
      {...numberFormatProps}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      prefix={numeric ? '' : "$"}
      decimalSeparator={false}
      isNumericString
      allowNegative={false}
      isAllowed={withValueCap}
    />
  );
}

InputMaxValue.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaxValue.js